<div *ngIf="!submitted || submitting">
    <H1>Transwestern Pipeline Company, LLC</H1>
    <b>Transfer Access Request</b>
    <form #form="ngForm">
        <div fxLayout="column">           
            <mat-card>
                <mat-card-title>Action Requested</mat-card-title>
                <mat-card-content>
                    <cad-lib-radio 
                    matTooltip
                    [resultProperty]="'code'"
                    [displayProperty]="'description'"
                    [data]="actionOptions"
                    [(selectValue)]="data.actionCd"
                    fxFlex></cad-lib-radio>   
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-title>User Information</mat-card-title>
                <mat-card-content>
                <div fxFlex fxLayout="column">
                    <div fxFlex col-span="2" fxLayout="column" *ngIf="data.actionCd!='add'" >
                        <mat-form-field>
                            <mat-label>Messenger User ID</mat-label>
                            <input matInput
                            [(ngModel)]="data.userId"
                            name="userId"
                            required
                            />
                        </mat-form-field>
                    </div>  
                    <div fxFlex col-span="2" *ngIf="data.actionCd!='remove'">
                        <mat-form-field fxFlex>
                            <mat-label>Company Name</mat-label>
                            <input matInput
                            [(ngModel)]="data.companies[0].companyName"
                            name="companyName"
                            required
                            maxlength="120"
                            />
                        </mat-form-field>
                    </div>
                    
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em" *ngIf="data.actionCd!='remove'">
                        <mat-form-field fxFlex>
                            <mat-label>First Name</mat-label>
                            <input matInput
                            [(ngModel)]="data.firstName"
                            name="firstName"
                            minlength="2"
                            maxlength="30"
                            required
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>Last Name</mat-label>
                            <input matInput
                            [(ngModel)]="data.lastName"
                            name="lastName"
                            minlength="2"
                            maxlength="30"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em" *ngIf="data.actionCd!='remove'">
                        <mat-form-field fxFlex>
                            <mat-label>Email</mat-label>
                            <input matInput
                            emailAddress
                            [(ngModel)]="data.email"
                            name="email"
                            required
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>Phone</mat-label>
                            <input matInput
                            [(ngModel)]="data.phone"
                            name="phone"
                            mask="(000) 000-0000"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex *ngIf="data.actionCd!='remove'">
                        <mat-form-field fxFlex>
                            <mat-label>Street Address</mat-label>
                            <input matInput
                            [(ngModel)]="data.address"
                            name="address"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em" *ngIf="data.actionCd!='remove'">
                        <mat-form-field fxFlex>
                            <mat-label>City</mat-label>
                            <input matInput
                            [(ngModel)]="data.city"
                            name="city"
                            required
                            />
                        </mat-form-field>
                        <cad-lib-auto-complete
                            fxFlex="25"
                            placeholder="State"
                            [required]="true"
                            [data]="states"
                            displayProperty="description"
                            resultProperty="code"
                            [sort]="true"
                            [(selectedData)]="data.stateCd">
                        </cad-lib-auto-complete>
                        <mat-form-field fxFlex>
                            <mat-label>Zip</mat-label>
                            <input matInput
                            [(ngModel)]="data.zip"
                            name="zip"
                            required
                            />
                        </mat-form-field>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card *ngIf="data.actionCd!='remove'">
            <mat-card-title>Roles and Access Types</mat-card-title>
            <mat-card-content>
                <div fxLayout="column">
                    <div fxFlex fxLayout="row" fxLayoutGap="1em" class="access-selections">
                        <div fxFlex="fill"><h3>Role Types:</h3></div>
                    </div>
                    <div fxFlex fxLayout="row wrap" fxLayoutGap="1em">
                        <div fxFlex="fill" *ngFor="let r of roles">
                            <mat-checkbox class="access-check" matInput [name]="r.code" labelPosition="before" (change)="checkSelected($event, r.code, 'roles')" [(ngModel)]="r.checked">{{r.description}}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    
    <mat-card>
        <mat-card-content>
            <div>
                <!-- <re-captcha (resolved)="captchaResolved($event)"></re-captcha> -->
                <!-- <re-captcha [(ngModel)]="captcha" name="captcha" required #captchaControl="ngModel"></re-captcha> -->
                <!-- <re-captcha (resolved)="resolved($event)" (errored)="onError($event)" errorMode="handled"></re-captcha> -->
                <re-captcha id="recaptcha" name="recaptcha" #recaptcha="ngModel" 
                [(ngModel)]="data.recaptchaToken" required 
                [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"></re-captcha>
            </div>
            <div fxLayout="row" fxLayoutAlign="left">
                <div fxFlex fxLayoutAlign="start">
                    <button type="submit" mat-raised-button color="primary" [disabled]="submitted || !form.form.valid || recaptcha.invalid || (data.roles.length === 0 && data.actionCd != 'remove')" (click)="submit()">Submit Request</button>
                    <button mat-raised-button (click)="clear()">Clear</button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
                 
    </form>
    <div class="loading" *ngIf="submitting">
        <mat-spinner></mat-spinner>
    </div>
</div>
<div *ngIf="submitted && !submitting">
    <car-submit-successful [name]="data.firstName" (submitAnother)="clear()"></car-submit-successful>
</div>